module.exports = __webpack_public_path__ + "static/img/applogo.b3ad73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applogo.png
// module id = lmfY
// module chunks = 49